import React, { Fragment } from 'react';
import HeaderPortal from '../../../components/layout/HeaderPortal';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_SYNC_DOCUMENT_STATE } from 'constants/rightsCodes';
import BrowserComponent from './BrowserComponent';

const Route = () => {
  return (
    <Fragment>
      <HeaderPortal />
      <PermissionCheck authorizationCode={ADMIN_SYNC_DOCUMENT_STATE}>
        <BrowserComponent />
      </PermissionCheck>
    </Fragment>
  );
};

export default Route;
